export default "__VITE_ASSET__C3icf9JP__"